/* global growsumo */
import axios from 'axios';
import Cookies from 'js-cookie';

import { cookieName } from '../../CookieScripts/variables';

export function getDataInHubspotFieldFormat(data) {
  const fieldNames = Object.keys(data);
  const result = fieldNames
    // in case of checkboxes, the "unchecked" value is false
    .filter((fieldName) => data[fieldName] || data[fieldName] === false)
    .map((fieldName) => ({
      name: fieldName,
      value: data[fieldName],
    }));

  return result;
}

/**
 * Submit HubSpot form with API endpoint
 * @param {Record<string, any} data form data to be submitted to the HubSpot form
 * @param {string} endpoint HubSpot form submission URL
 * @returns {Promise<any>}
 */
export function registerLead(data, endpoint) {
  const fields = getDataInHubspotFieldFormat(data);

  return axios.post(endpoint, {
    fields,
    // add `hubspotutk` cookie, ref: https://legacydocs.hubspot.com/docs/methods/forms/submit_form
    context: {
      hutk: Cookies.get('hubspotutk'),
    },
  });
}

export function getCurrentURL() {
  const utmCookie = Cookies.get(cookieName) || '';
  if (utmCookie.length) {
    return `${window.location.origin}${window.location.pathname}${utmCookie}`;
  }
  return window.location.href;
}

export function createPartnerStackSignup({ name, email }) {
  return new Promise((resolve) => {
    growsumo.data.name = name;
    growsumo.data.email = `${email}@remote.com`;
    growsumo.data.customer_key = email;
    growsumo.createSignup(resolve);
  });
}
export function getPartnerKey() {
  return growsumo && growsumo.data ? growsumo.data.partner_key : '';
}
